// extracted by mini-css-extract-plugin
export default {"title":"dP3G9htmq7BDf95m0m1L","cta":"McXAYLe_SDSnoQbZwExZ"};